export const keys = {
	DISCOVER_ROUTE: 'discover.route.last',
	GLOBAL_SIDEBAR_PANEL: 'sidebar.global.panel',
	EDITOR_SURVEY_LAST_SUBMITTED: 'editor.survey.last.submitted',
	SUPERADMIN_SURVEY_REQUESTED: 'superadmin.survey.requested',
	SUPERADMIN_SURVEY_SUBMITTED: 'superadmin.survey.submitted',
	SUPERADMIN_SESSION_EXPIRED: 'superadmin.session.expired',
	RESTRICTED_PAGE_CONFIRMED: 'restricted.page.confirmed',
	HOME_ONBOARDING: 'home.onboarding',
	PAGE_JUST_CONVERTED: 'migration.page.just.converted',
	NAVIGATION_CLASSIC_OPT_OUT: 'navigation.classic.opt.out',
	NAVIGATION_HOME_OPT_OUT: 'navigation.home.opt.out',
	NAVIGATION_DEFAULT_OPTED_OUT: 'navigation.default.opted.out',
	NAVIGATION_OPT_IN_SEEN_SPOTLIGHT: 'navigation.opt.in.seen.spotlight',
	NAVIGATION_CLICKED_LOUD_OPT_IN_OR_VIEWED_FLAG: 'navigation.clicked.loud.opt.in.or.viewed.flag',
	NOTIFICATION_SPOTLIGHT_VIEWED: 'notification.spotlight.viewed',
	HOME_SECTION_COLLAPSED: 'home.section.collapsed',
	RECENTLY_WATCHED_SPACE: 'recentlyWatchedSpace',
	GROWTH_EXPERIMENT_REQUEST_UPGRADE_SENT: 'growth.experiment.request.upgrade.sent',
	GROWTH_EXPERIMENT_UPGRADE_DISMISSED_COUNT: 'growth.experiment.engagedUpgrade.dismissed.count',
	GROWTH_EXPERIMENT_UPGRADE_LAST_DISMISSED_DATE:
		'growth.experiment.engagedUpgrade.last.dismissed.date',
	LOCAL_STORAGE_DISPLAYS_NEXT_AT_KEY: 'growth.experiment.engagedBilling.displays.next.at',
	LOCAL_STORAGE_HAS_BILLING_DETAILS: 'growth.experiment.engagedBilling.has.billing.details',
	LOCAL_STORAGE_BILLING_API_NEXT_CALLED_AT_KEY:
		'growth.experiment.engagedBilling.billing.api.next.called.at',
	LOCAL_STORAGE_CONTENT_VIEW_CLOSEST_ELEMENT_SCROLL_POSITION:
		'ce.content.view.best.element.scroll.position',

	CONFLUENCE_SLACK_APP_IS_ENABLED: 'growth.experiment.confluence.slack-is-enabled',

	INVITE_ON_LINK_INSERT_DISMISSAL_COUNT:
		'growth.experiment.confluence.invite-on-link-insert-dismissal-count',
	INVITE_ON_LINK_INSERT_OPT_OUT: 'growth.experiment.confluence.invite-on-link-insert-opt-out',

	CROSS_JOIN_NUDGES_V3_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-v3-visited',

	CROSS_JOIN_NUDGES_JPD_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-jpd-visited',

	CROSS_JOIN_NUDGES_MSR_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-msr-visited',

	CROSS_JOIN_NUDGES_MSR_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-msr-opt-out',

	CROSS_JOIN_NUDGES_MSR_VISITED_COUNT:
		'growth.experiment.confluence.cross-join-nudges-msr-visited-count',

	CROSS_JOIN_NUDGES_V3_VISITED_COUNT:
		'growth.experiment.confluence.cross-join-nudges-v3-visited-count',

	CROSS_JOIN_NUDGES_JPD_VISITED_COUNT:
		'growth.experiment.confluence.cross-join-nudges-jpd-visited-count',

	CROSS_JOIN_NUDGES_V3_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-v3-opt-out',

	CROSS_JOIN_NUDGES_JPD_USER_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-jpd-opt-out',

	CROSS_JOIN_NUDGES_ELIGIBILITY_KEY: 'growth.experiment.confluence.cross-join-nudges-eligibility',

	CROSS_JOIN_NUDGES_EVENT_CACHE_KEY: 'growth.experiment.confluence.cross-join-nudges-event-cache',

	CROSS_JOIN_NUDGES_LOOM_EVENT_CACHE_KEY:
		'growth.experiment.confluence.cross-join-nudges-loom-event-cache',

	CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_KEY:
		'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited',

	CROSS_JOIN_THIRD_PARTY_NUDGES_VISITED_COUNT:
		'growth.experiment.confluence.cross-join-third-party-nudges-v2-visited-count',

	CROSS_JOIN_NUDGES_LOOM_VISITED_KEY: 'growth.experiment.confluence.cross-join-nudges-loom-visited',

	CROSS_JOIN_NUDGES_LOOM_VISITED_COUNT:
		'growth.experiment.confluence.cross-join-nudges-loom-visited-count',

	CROSS_JOIN_NUDGES_LOOM_OPT_OUT: 'growth.experiment.confluence.cross-join-nudges-loom-opt-out',

	/**
	 * The width of the right panel on Home
	 */
	HOME_SIDEBAR_WIDTH: 'home.sidebar.width',

	/**
	 * Used to store starred/favorited feature flags for the dev tools panel
	 */
	STARRED_FEATURE_FLAGS: 'confluence-frontend-next.starredFeatureFlags',

	/**
	 * Indicates that "Copy space permissions" (implemented by
	 * @confluence/copy-space-permissions) has completed i.e. space permissions
	 * have been copied.
	 */
	COPIED_SPACE_PERMISSIONS: 'copied.space.permissions',
	PERSIST_SCROLL_POSITION_IN_VIEW_PAGE: 'editor-persit-scroll-position',
	ID_START_CONTENT_IN_VIEW_PAGE: 'main-content',
	FABRIC_PAGE_OPTIN_MIGRATION_BANNER: 'fabric.page.optin.migration.banner.discovery.feature',
	FABRIC_TEMPLATE_MIGRATION_SUCCESS_FLAG: 'fabric-template-migration.success.flag',
	FABRIC_TEMPLATE_MIGRATION_ERROR_FLAG: 'fabric-template-migration.error.flag',
	BYLINE_APPS_SHOW_ALL: 'byline.apps.show-all',
	SPACENAV_APPS_SHOW_ALL: 'spacenav.apps.show-all',
	HIDE_BULK_CONFIRMATION_DIALOG_LOCAL_STORAGE_KEY:
		'archive-pages.bulk-archive.confirmation-dialog.opt-out',
	ONBOARDING_STEP_INDEX: 'onboarding.account.setup.step.index',
	ONBOARDING_STEP_HAS_TEAM_NAME: 'onboarding.account.setup.step.hasTeamName',
	ONBOARDING_FORM_VALUES: 'onboarding.account.setup.form.values',
	RIGHT_SIDEBAR: 'right.sidebar',
	CONNECT_APP_ANALYTICS: 'ecosystem.confluence.connect.analytics',
	/**
	 * Auto Convert TinyMCE pages
	 */
	EDITOR_REVERTED: 'autoconverted.pages.reverted',

	BLOGPOST_PERMISSIONS_NOTICE: 'blogpost.permissions.notice.error',
	QUERY_OVERRIDES: 'query.overrides',

	CANVAS_SERVER: 'canvas-server',
	CANVAS_RELAY: 'canvas-relay',
	CANVAS_FRONTEND_VERSION: 'canvas-frontend-version',

	CACHED_ASSETS: 'confluence.cachedAssets',

	// Automation changeboarding
	DISMISS_SMART_BUTTON_SPACE_NAVIGATION_CHANGEBOARDING:
		'dismissSmartButtonSpaceNavigationChangeBoarding',

	// Below are cc-automation keys for in-context discoverability messages
	AUTOMATION_DISCOVER_ARCHIVE_FROM_OVERFLOW_MENU: 'automation.discover.archive-from-overflow-menu',
	AUTOMATION_DISCOVER_ARCHIVE_FROM_HOVER_OVER_PAGE_TITLE:
		'automation.discover.archive-from-hover-over-page-title',
	AUTOMATION_DISCOVER_BULK_ARCHIVE: 'automation.discover.bulk-archive',
	AUTOMATION_DISCOVER_BULK_CHANGE_PAGE_OWNER: 'automation.discover.bulk-change-page-owner',
	AUTOMATION_DISCOVER_ADD_LABEL_TO_PAGE: 'automation.discover.add-label-to-page',
	AUTOMATION_DISCOVER_MEETING_NOTES_TEMPLATE: 'automation.discover.meeting-notes-template',
	AUTOMATION_DISCOVER_JIRA_LINK: 'automation.discover.jira-link',
	AUTOMATION_DISCOVER_PAGE_PUBLIC_LINK: 'automation.discover.page-public-link',
	AUTOMATION_DISCOVER_GLOBAL_PUBLIC_LINK: 'automation.discover.global-public-link',
	AUTOMATION_DISCOVER_SPACE_ASSIGNED_BULK: 'automation.discover.space-assigned-bulk',
	AUTOMATION_DISCOVER_SPACE_ASSIGNED_INDIVIDUAL: 'automation.discover.space-assigned-individual',
	AUTOMATION_DISCOVER_GLOBAL_DEFAULT_SPACE: 'automation.discover.global-default-space',
	AUTOMATION_DISCOVER_VERIFIED_CONTENT: 'automation.discover.verified.content',
	AUTOMATION_DISCOVER_WHITE_BOARDS: 'automation.discover.publish.white.boards',
	AUTOMATION_DISCOVER_SHARE_SLACK: 'automation.discover.share.slack',
	AUTOMATION_DISCOVER_SET_CONTENT_STATE: 'automation.discover.set-content-state',
	AUTOMATION_DISCOVER_PRODUCT_REQUIREMENTS: 'automation.discover.product-requirements',
	AUTOMATION_DISCOVER_FEEDBACK_ANALYSIS: 'automation.discover.feedback-analysis',
	AUTOMATION_DISCOVER_RELEASE_NOTES: 'automation.discover.release-notes',
	AUTOMATION_ONBOARDING: 'automation.onboarding',
	AUTOMATION_EXECUTION_LIMIT: 'automation.execution.limit',

	SPACE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'space-settings-nav.sections.expand-states',
	SITE_SETTINGS_NAV_SECTIONS_EXPANDED_STATES: 'site-settings-nav.sections.expand-states',
	/**
	 * Comment Drafts
	 */
	COMMENT_DRAFTS_PAGE_CREATE: 'comments.drafts.page.create',
	COMMENT_DRAFTS_PAGE_EDIT: 'comments.drafts.page.edit',
	COMMENT_DRAFTS_PAGE_REPLY: 'comments.drafts.page.reply',
	COMMENT_DRAFTS_INLINE_CREATE: 'comments.drafts.inline.comments.create',
	COMMENT_DRAFTS_INLINE_EDIT: 'comments.drafts.inline.comments.edit',
	COMMENT_DRAFTS_INLINE_REPLY: 'comments.drafts.inline.reply',
	COMMENT_DRAFTS_EDITOR_INLINE_CREATE: 'comments.drafts.editor.inline.create',
	COMMENT_DRAFTS_EDITOR_INLINE_EDIT: 'comments.drafts.editor.inline.edit',
	COMMENT_DRAFTS_EDITOR_INLINE_REPLY: 'comments.drafts.editor.inline.reply',
	LOOM_BETA_ENABLED: 'loom.beta.enabled',
	BROWSER_BANNER_CLOSED_BY_USER: 'devloop.browser-support-warning.closed',

	/**
	 * Home Feeds
	 */
	HOME_FOLLOWING_FEED_SESSION_ID: 'home.follow-feed.sessionId',
	HOME_POPULAR_FEED_SESSION_ID: 'home.popular-feed.sessionId',
	HOME_FOLLOWING_FEED_SORTING: 'home.follow-feed.sorting',
	HOME_POPULAR_FEED_TIME_GRANULARITY: 'home.popular-feed.time-granularity',

	/**
	 * Live Pages
	 */
	LIVE_PAGES_MODE_SWITCHING_FLAG_SHOWN: 'live-pages.mode-switcher.flag.shown',
	LIVE_DOCS_HAS_INIT_MODERNIZE: 'live-docs.has-init-modernize',
	LIVE_DOCS_HAS_INIT_MODERNIZE_POST_EXP: 'live-docs.has-init-modernize-post-exp',
	LIVE_DOCS_NEW_LOZENGE_SHOWN_TRACKER: 'live-docs.new-lozenge-shown-tracker',

	/**
	 * Template Creation Tracking
	 */
	PAGE_CREATED_FROM_TEMPLATE_PREFIX: 'page-created-from-template-',

	/**
	 * Editor Offline Storage
	 */
	EDITOR_OFFLINE_LAST_BACKGROUND_CLEANUP_ATTEMPT: 'editor:offline:last-background-cleanup-attempt',

	/**
	 * Loom AI Meeting Notes Cross-Flow
	 */
	USER_HAS_CLICKED_ON_MEETING_NOTES_TEMPLATE: 'lamnic-user-clicked-on-meeting-notes',

	/**
	 * Databases Extension
	 * !IMPORTANT: This key should not be renamed as canvas/database uses it to determine which template to apply
	 */
	DATABASES_CREATE_WITH_TEMPLATE_TYPE: 'databases-create-with-template-type',

	/**
	 * Explore Related Work
	 */
	EXPLORE_RELATED_WORK_FEEDBACK_BANNER: 'explore-related-work.confluence.feedback-banner',

	/**
	 * Editor Controls
	 */
	EDITOR_CONTROLS_INITIAL_PREFERENCES: 'editor-controls.initial-preferences',

	/**
	 * Upgrade Free Pool Target Experiment
	 */
	UPFT_CONFLUENCE_STANDARD_OFFER_COHORT: 'atl-UPFTConfluenceStandardOfferCohort',

	/**
	 * Automation Platform
	 * Used to override the automation stack for development/staging
	 */
	AUTOMATION_PLATFORM_STACK: 'automationPlatform:automationStack',

	HAS_INIT_AIFC_EXP: 'ai-first-creation.has-init-aifc-exp',
	CREATE_WITH_ROVO_MODAL_CLOSE_FEEDBACK_FLAG_LAST_SHOWN:
		'create-with-rovo-modal-close-feedback-flag.last-shown',
	CREATE_WITH_ROVO_UPDATE_COMPLETE_FEEDBACK_FLAG_LAST_SHOWN:
		'create-with-rovo-update-complete-feedback-flag.last-shown',
	AIFC_CREATE_SPOTLIGHT_SESSION_KEY: 'aifc-create-spotlight-session-key',

	/**
	 * Confluence Notes
	 */
	NOTES_FLOATING_POSITION: 'confluence-notes.floating-position',

	UNIVERSAL_SHORTCUTS_HIDE_PROMPT_UNTIL: 'universal-shortcuts.deprecated-shortcut-flag.hide-until',

	// Mention Reminders experiment
	MENTION_REMINDERS_SENT: 'mention-reminders.experiment.sent',

	// Nav 4 Site/Space settings back button URL
	NAV4_SETTINGS_BACK_BUTTON_URL: 'navigation.settings.back-button.url',
	// Nav 4 opt out cache
	NAV4_OPT_OUT_CACHE: 'navigation.opt-out',
	// Nav 4 admin opt in cache
	NAV4_ADMIN_OPT_IN_CACHE: 'navigation.admin.opt-in',

	// EOT Banner experiment
	EOT_BANNER_DISMISS_UNTIL: 'eot-banner.dismiss-until',

	// Issue Create
	ISSUE_CREATE_WITH_AI: 'issue-create.with-ai',

	// AI Unsplash Header Experiment
	AI_UNSPLASH_HEADER_ACCEPTED: 'ai-unsplash.header.accepted',

	//Notify User On 1st View expeirment
	NOTIFY_USERS_ON_FIRST_VIEW_MUTATION_FIRED: 'notify-users-on-first-view.mutation.fired',

	NAVDEX_STORAGE_KEY: 'navigationSession',

	// Super Admin Timeout
	SUPER_ADMIN_TIMEOUT: 'confluence.super.admin.timeout',

	// Premium Onboarding
	PTO_PHASE_TWO_SPOTLIGHT_TARGET: 'pto-phase-two-spotlight',

	// Migrations
	IMPORT_CONTENT_TIMESTAMP: 'importContentTimestamp',

	// Page Experience
	AE_TABLE_COPIED: 'copied',
	AE_TABLE_COPIED_COLS: 'copiedCols',

	// Classic Editor Dialogs
	LAST_TAB: 'last-tab',

	// AI Audio Playback Speed
	AI_AUDIO_PLAYBACK_SPEED: 'ai.audio.playback-speed',
	AI_AUDIO_BRIEFING_CUSTOMIZATION: 'ai.audio.briefing.customization',

	// EditorTeamCreatedFlag
	RETROSPECTIVE_BLUEPRINT_TEAM_CREATED: 'retrospective-blueprint.team.created',
	RETROSPECTIVE_BLUEPRINT_TEAM_USED: 'retrospective-blueprint.team.used',

	// Confluence Custom Origins
	CONFLUENCE_CUSTOM_ORIGINS: 'confluenceCustomOrigins',

	// Dev and Testing
	HIDE_FEATURE_FLAG_ICON: 'confluence-frontend-next.hideFeatureFlagIcon',
	FE_FIXTURE_PARAMS: '__confluence-frontend-fixture-params',
	TEST_FAILURES_LINK_MODE: 'testFailuresLink.mode',
	TEST_FAILURES_LINK_OPERATIONS_PREFIX: 'testFailuresLink.operations.',

	// Disable Engagement for tests
	DISABLE_ENGAGEMENT_FOR_TESTS: 'confluence.disable-engagement-for-tests',

	// Feature Discovery Override
	FEATURE_DISCOVERY_OVERRIDE_PREFIX: 'featureDiscoveryOverride-',

	// Realtime Access Requests:
	LAST_SHOWN_REALTIME_REQUEST_CREATED_AT: 'lastShownRealtimeRequestCreatedAt',
	LAST_TIME_ACCESS_REQUESTS_DIALOG_WAS_OPENED: 'lastTimeAccessRequestsDialogWasOpened',

	// Chrome Extension
	CONFLUENCE_SSR_OUTLINE_PRIORITY: 'confluence.ssr-outline-priority',
	CONFLUENCE_SSR_OUTLINE_ENABLED: 'confluence.ssr-outline-enabled',
	CONFLUENCE_LOADABLE_STEP_OVER_ENABLED: 'confluence.loadable-step-over-enabled',

	// Rovo AI Search Config Override (local development)
	X_USE_CONVO_PUBLIC_API: 'x_use_convo_public_api',
	X_PUBLIC_API_TOKEN: 'x_public_api_token',
};

export const PERSISTED_KEYS_ON_SERVER = {
	//keys stored on backend start with persisted
	PERSISTED_LEFT_SIDEBAR_WIDTH: 'persisted.left.sidebar.width',
	PERSISTED_LEFT_SIDEBAR_COLLAPSED: 'persisted.left.sidebar.collapsed',
	PERSISTED_GROWTH_PERSISTENT_UPGRADE_PRETRIAL_BANNER:
		'persisted.growth.persistent.upgrade.preTrial.banner',
	PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES: 'persisted.space-nav.sections.expand-states',

	// Overrided feature flags. These are persisted to the server so they can be
	// used when rendering in SSR
	PERSISTED_OVERRIDES_STATSIG: 'persisted.enterprise-experience.override.statsig',

	PERSISTED_ADMIN_ANNOUNCEMENT_BANNER: 'persisted.admin.announcement.banner',

	PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT:
		'persisted.admin.announcement.banner.migrator.prompt',

	PERSISTED_STORAGE_ENFORCEMENT_BANNER: 'persisted.storage.enforcement.banner',

	// Public Links Modals
	PERSISTED_RESTRICTIONS_DIALOG_PUBLIC_LINKS_MODAL:
		'persisted.restrictions.dialog.public.links.modal',
	PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL:
		'persisted.share.dialog.public.links.toggle.on.modal',
	PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_ON_MODAL_SMART_SECTIONS:
		'persisted.share.dialog.public.links.toggle.on.modal.smart.sections',
	PERSISTED_SHARE_DIALOG_PUBLIC_LINKS_TOGGLE_OFF_MODAL:
		'persisted.share.dialog.public.links.toggle.off.modal',
	// Public Links Edit Whiteboard Banner
	PERSISTED_PUBLIC_LINKS_EDIT_WHITEBOARD_BANNER: 'persisted.public.links.edit.whiteboard.banner',

	// Theming
	PERSISTED_USER_THEME_PREFERENCE: 'persisted.ecosystem.user.theme.preference',

	// Premium feature highlight
	PERSISTED_PREMIUM_FEATURE_HIGHLIGHT: 'persisted.premium.feature.highlight',

	// Reading Aids
	PERSISTED_READING_AIDS_AUTO_HIGHLIGHT: 'persisted.reading.aids.auto.highlight',

	// AIFC Banner Persistence
	PERSISTED_SMART_CREATE_FEEDBACK_BANNER_LAST_DISMISSED:
		'persisted.smart-create.feedback-banner.last-dismissed',

	// Editor Controls
	PERSISTED_EDITOR_CONTROLS_ONBOARDING_BANNER_NEW_PINNING_DISMISSED:
		'persisted.editor-controls.onboarding-banner-new-pinning.dismissed',

	//Role Based Access Control
	PERSISTED_RBAC_TRACKING: 'persisted.rbac.tracking',
	PERSISTED_RBAC_BANNER_DISMISSED: 'persisted.rbac.banner.dismissed',

	// Loom cross_flow ad-control not interested preference
	PERSISTED_LOOM_CROSS_FLOW_AD_CONTROL_NOT_INTERESTED:
		'persisted.loom-cross-flow.ad-control.not-interested',

	// Status of exposure to a series of spotlight pulse outlines
	// highlighting Loom entrypoints to cross-sell-eligible customers
	PERSISTED_LOOM_CROSS_SELL_DISCOVERABILITY_PULSES_HAVE_ENDED:
		'persisted.loom-cross-sell.discoverability-pulses.have-ended',

	// Jira Cloud ID preference for site picker on Jira Issue Create
	PERSISTED_JIRA_CLOUD_ID_PREFERENCE: 'persisted.jira-cloud-id.preference',

	// Selected site, project and issue type from the configure view on bulk AI Jira Issue Create
	PERSISTED_BULK_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.bulk-create.jira.config.for.user',

	// Selected site, project and issue type from the single work create form
	PERSISTED_SINGLE_CREATE_JIRA_CONFIG_FOR_USER: 'persisted.single-create.jira.config.for.user',
	PERSISTED_SHOULD_USE_GIC_EMBED: 'persisted.should-use-gic-embed',

	// Importers
	PERSISTED_IMPORT_FEEDBACK_DISABLED: 'persisted.imports.import-feedback-disabled',

	PERSISTED_RT_PAID_FEATURE_EDUCATION_SPOTLIGHT_SEEN:
		'persisted.rt-paid-feature-education.spotlight.seen',

	// Search Platform QuickFind Ghost Text
	PERSISTED_PLATFORM_QUICKFIND_GHOSTTEXT: 'persisted.platform.quickfind.ghosttext',
	PERSISTED_LEGACY_CONTENT_REPORT_TASK_ID: 'persisted.legacy-content.report.task-id',

	// Confluence Recap sidebar collapse flag (first visit only)
	PERSISTED_RECAP_SIDEBAR_COLLAPSED: 'persisted.recap.sidebar.collapsed',
};
